import { type AmbitoDTO } from '@framework/api-client/api/inquiries/schemas/ambitoDTO.ts';

export interface INestedScope extends AmbitoDTO {
  children?: INestedScope[];
}

export function getIndentScopes(rawScopes: AmbitoDTO[]) {
  // Costruisce una mappa degli ambiti basata sul loro id per un accesso più efficiente
  const scopeMap = new Map<string, AmbitoDTO>();

  rawScopes.forEach(scope => {
    scopeMap.set(scope.id!, scope);
  });

  const buildNestedScopes = (scope: AmbitoDTO): INestedScope => {
    const nestedScope: INestedScope = { ...scope };
    const children = rawScopes.filter(child => child.idPadre === scope.id);
    if (children.length > 0) {
      nestedScope.children = children.map(child => buildNestedScopes(child));
    }
    return nestedScope;
  };

  // Trova gli ambiti radice che non hanno idPadre
  const rootScopes = rawScopes.filter(scope => scope.idPadre == null);

  // Costruisce la struttura nidificata degli ambiti a partire dagli ambiti radice
  const indentScopes = rootScopes.map(scope => buildNestedScopes(scope));

  return indentScopes;
}
